import { ApiAbstract } from '../abstract';
import { RestorePassword } from '../../../types/restorePassword';

export class ApiRestorePassword extends ApiAbstract<RestorePassword, any> {}
